export default [
  "1月1日-3分9秒",
  "1月2日-3分38秒",
  "1月3日-4分6秒",
  "1月4日-4分33秒",
  "1月5日-5分1秒",
  "1月6日-5分27秒",
  "1月7日-5分54秒",
  "1月8日-6分20秒",
  "1月9日-6分45秒",
  "1月10日-7分10秒",
  "1月11日-7分35秒",
  "1月12日-7分59秒",
  "1月13日-8分22秒",
  "1月14日-8分45秒",
  "1月15日-9分7秒",
  "1月16日-9分28秒",
  "1月17日-9分49秒",
  "1月18日-10分9秒",
  "1月19日-10分28秒",
  "1月20日-10分47秒",
  "1月21日-11分5秒",
  "1月22日-11分22秒",
  "1月23日-11分38秒",
  "1月24日-11分54秒",
  "1月25日-12分8秒",
  "1月26日-12分22秒",
  "1月27日-12分35秒",
  "1月28日-12分59秒",
  "1月29日-13分10秒",
  "1月30日-13分19秒",
  "1月31日-13分37秒",

  "2月1日-13分44秒",
  "2月2日-13分50秒",
  "2月3日-13分56秒",
  "2月4日-14分1秒",
  "2月5日-14分5秒",
  "2月6日-14分9秒",
  "2月7日-14分11秒",
  "2月8日-14分13秒",
  "2月9日-14分14秒",
  "2月10日-14分15秒",
  "2月11日-14分14秒",
  "2月12日-14分13秒",
  "2月13日-14分11秒",
  "2月14日-14分8秒",
  "2月15日-14分5秒",
  "2月16日-14分1秒",
  "2月17日-13分56秒",
  "2月18日-13分51秒",
  "2月19日-13分44秒",
  "2月20日-13分38秒",
  "2月21日-13分30秒",
  "2月22日-13分22秒",
  "2月23日-13分13秒",
  "2月24日-11分4秒",
  "2月25日-12分54秒",
  "2月26日-12分43秒",
  "2月27日-12分32秒",
  "2月28日-12分21秒",
  "2月29日-12分8秒",

  "3月1日-11分56秒",
  "3月2日-11分43秒",
  "3月3日-11分29秒",
  "3月4日-11分15秒",
  "3月5日-11分1秒",
  "3月6日-10分47秒",
  "3月7日-10分32秒",
  "3月8日-10分16秒",
  "3月9日-10分1秒",
  "3月10日-9分45秒",
  "3月11日-9分28秒",
  "3月12日-9分12秒",
  "3月13日-8分55秒",
  "3月14日-8分38秒",
  "3月15日-8分21秒",
  "3月16日-8分4秒",
  "3月17日-7分46秒",
  "3月18日-7分29秒",
  "3月19日-7分11秒",
  "3月20日-6分53秒",
  "3月21日-6分35秒",
  "3月22日-6分17秒",
  "3月23日-5分58秒",
  "3月24日-5分40秒",
  "3月25日-5分22秒",
  "3月26日-5分4秒",
  "3月27日-4分45秒",
  "3月28日-4分27秒",
  "3月29日-4分9秒",
  "3月30日-3分51秒",
  "3月31日-3分33秒",


  "4月1日-3分16秒",
  "4月2日-2分58秒",
  "4月3日-2分41秒",
  "4月4日-2分24秒",
  "4月5日-2分7秒",
  "4月6日-1分50秒",
  "4月7日-1分33秒",
  "4月8日-1分17秒",
  "4月9日-1分1秒",
  "4月10日+0分46秒",
  "4月11日+0分30秒",
  "4月12日+0分16秒",
  "4月13日+0分1秒",
  "4月14日+0分13秒",
  "4月15日+0分27秒",
  "4月16日+0分41秒",
  "4月17日+0分54秒",
  "4月18日+1分6秒",
  "4月19日+1分19秒",
  "4月20日+1分31秒",
  "4月21日+1分42秒",
  "4月22日+1分53秒",
  "4月23日+2分4秒",
  "4月24日+2分14秒",
  "4月25日+2分23秒",
  "4月26日+2分33秒",
  "4月27日+2分41秒",
  "4月28日+2分49秒",
  "4月29日+2分57秒",
  "4月30日+3分4秒",

  "5月1日+1分10秒",
  "5月2日+3分16秒",
  "5月3日+3分21秒",
  "5月4日+3分26秒",
  "5月5日+3分30秒",
  "5月6日+3分37秒",
  "5月7日+3分36秒",
  "5月8日+3分39秒",
  "5月9日+3分40秒",
  "5月10日+3分42秒",
  "5月11日+3分42秒",
  "5月12日+3分42秒",
  "5月13日+3分42秒",
  "5月14日+3分41秒",
  "5月15日+3分39秒",
  "5月16日+3分37秒",
  "5月17日+3分34秒",
  "5月18日+3分31秒",
  "5月19日+3分27秒",
  "5月20日+3分23秒",
  "5月21日+3分18秒",
  "5月22日+3分13秒",
  "5月23日+3分7秒",
  "5月24日+3分1秒",
  "5月25日+2分54秒",
  "5月26日+2分47秒",
  "5月27日+2分39秒",
  "5月28日+2分31秒",
  "5月29日+2分22秒",
  "5月30日+2分13秒",
  "5月31日+2分4秒",

  "6月1日+1分54秒",
  "6月2日+1分44秒",
  "6月3日+1分34秒",
  "6月4日+1分23秒",
  "6月5日+1分12秒",
  "6月6日+1分0秒",
  "6月7日+0分48秒",
  "6月8日+0分36秒",
  "6月9日+0分24秒",
  "6月10日+0分12秒",
  "6月11日+0分1秒",
  "6月12日+0分14秒",
  "6月13日+0分39秒",
  "6月14日+0分52秒",
  "6月15日-1分5秒",
  "6月16日-1分18秒",
  "6月17日-1分31秒",
  "6月18日-1分45秒",
  "6月19日-1分57秒",
  "6月20日-2分10秒",
  "6月21日-2分23秒",
  "6月22日-2分36秒",
  "6月23日-2分48秒",
  "6月24日-3分1秒",
  "6月25日-3分13秒",
  "6月26日-3分25秒",
  "6月27日-3分37秒",
  "6月28日-3分49秒",
  "6月29日-4分0秒",
  "6月30日-4分11秒",

  "7月1日-4分22秒",
  "7月2日-4分33秒",
  "7月3日-4分43秒",
  "7月4日-4分53秒",
  "7月5日-5分2秒",
  "7月6日-5分11秒",
  "7月7日-5分20秒",
  "7月8日-5分28秒",
  "7月9日-5分36秒",
  "7月10日-5分43秒",
  "7月11日-5分50秒",
  "7月12日-5分56秒",
  "7月13日-6分2秒",
  "7月14日-6分8秒",
  "7月15日-6分12秒",
  "7月16日-6分16秒",
  "7月17日-6分20秒",
  "7月18日-6分23秒",
  "7月19日-6分25秒",
  "7月20日-6分27秒",
  "7月21日-6分29秒",
  "7月22日-6分29秒",
  "7月23日-6分29秒",
  "7月24日-6分29秒",
  "7月25日-6分28秒",
  "7月26日-6分26秒",
  "7月27日-6分24秒",
  "7月28日-6分21秒",
  "7月29日-6分17秒",
  "7月30日-6分13秒",
  "7月31日-6分8秒",

  "8月1日-6分3秒",
  "8月2日-5分57秒",
  "8月3日-5分51秒",
  "8月4日-5分44秒",
  "8月5日-5分36秒",
  "8月6日-5分28秒",
  "8月7日-5分19秒",
  "8月8日-5分10秒",
  "8月9日-5分0秒",
  "8月10日-4分50秒",
  "8月11日-4分39秒",
  "8月12日-4分27秒",
  "8月13日-4分15秒",
  "8月14日-4分2秒",
  "8月15日-3分49秒",
  "8月16日-3分36秒",
  "8月17日-3分21秒",
  "8月18日-3分7秒",
  "8月19日-2分51秒",
  "8月20日-2分36秒",
  "8月21日-2分20秒",
  "8月22日-2分3秒",
  "8月23日-1分47秒",
  "8月24日-1分29秒",
  "8月25日-1分12秒",
  "8月26日+0分54秒",
  "8月27日+0分35秒",
  "8月28日+0分17秒",
  "8月29日+0分2秒",
  "8月30日+0分21秒",
  "8月31日+0分41秒",


  "9月1日+1分0秒",
  "9月2日+1分20秒",
  "9月3日+1分40秒",
  "9月4日+2分1秒",
  "9月5日+2分21秒",
  "9月6日+2分42秒",
  "9月7日+3分3秒",
  "9月8日+3分3秒",
  "9月9日+3分24秒",
  "9月10日+3分45秒",
  "9月11日+4分6秒",
  "9月12日+4分27秒",
  "9月13日+4分48秒",
  "9月14日+5分10秒",
  "9月15日+5分31秒",
  "9月16日+5分53秒",
  "9月17日+6分14秒",
  "9月18日+6分35秒",
  "9月19日+6分57秒",
  "9月20日+7分18秒",
  "9月21日+7分39秒",
  "9月22日+8分0秒",
  "9月23日+8分21秒",
  "9月24日+8分42秒",
  "9月25日+9分2秒",
  "9月26日+9分22秒",
  "9月27日+9分42秒",
  "9月28日+10分2秒",
  "9月29日+10分21秒",
  "9月30日+10分40秒",

  "10月1日+10分59秒",
  "10月2日+11分18秒",
  "10月3日+11分36秒",
  "10月4日+11分36秒",
  "10月5日+11分53秒",
  "10月6日+12分11秒",
  "10月7日+12分28秒",
  "10月8日+12分44秒",
  "10月9日+12分60秒",
  "10月10日+13分16秒",
  "10月11日+13分16秒",
  "10月12日+13分31秒",
  "10月13日+13分45秒",
  "10月14日+13分59秒",
  "10月15日+14分13秒",
  "10月16日+14分26秒",
  "10月17日+14分38秒",
  "10月18日+14分50秒",
  "10月19日+15分1秒",
  "10月20日+15分12秒",
  "10月21日+15分21秒",
  "10月22日+15分31秒",
  "10月23日+15分40秒",
  "10月24日+15分48秒",
  "10月25日+15分55秒",
  "10月26日+16分1秒",
  "10月27日+16分7秒",
  "10月28日+16分12秒",
  "10月29日+16分16秒",
  "10月30日+16分20秒",
  "10月31日+16分22秒",


  "11月1日+16分24秒",
  "11月2日+16分25秒",
  "11月3日+16分25秒",
  "11月4日+16分24秒",
  "11月5日+16分23秒",
  "11月6日+16分21秒",
  "11月7日+16分17秒",
  "11月8日+16分13秒",
  "11月9日+16分9秒",
  "11月10日+16分3秒",
  "11月11日+15分56秒",
  "11月12日+15分49秒",
  "11月13日+15分41秒",
  "11月14日+15分32秒",
  "11月15日+15分22秒",
  "11月16日+15分11秒",
  "11月17日+14分60秒",
  "11月18日+14分47秒",
  "11月19日+14分34秒",
  "11月20日+14分20秒",
  "11月21日+14分6秒",
  "11月22日+13分50秒",
  "11月23日+13分34秒",
  "11月24日+13分17秒",
  "11月25日+12分59秒",
  "11月26日+12分40秒",
  "11月27日+12分21秒",
  "11月28日+12分1秒",
  "11月29日+11分40秒",
  "11月30日+11分18秒",

  "12月1日+10分56秒",
  "12月2日+10分33秒",
  "12月3日+10分9秒",
  "12月4日+9分45秒",
  "12月5日+9分21秒",
  "12月6日+8分55秒",
  "12月7日+8分29秒",
  "12月8日+8分3秒",
  "12月9日+7分36秒",
  "12月10日+7分9秒",
  "12月11日+6分42秒",
  "12月12日+6分14秒",
  "12月13日+5分46秒",
  "12月14日+5分17秒",
  "12月15日+4分48秒",
  "12月16日+4分19秒",
  "12月17日+3分50秒",
  "12月18日+3分21秒",
  "12月19日+2分51秒",
  "12月20日+2分22秒",
  "12月21日+1分52秒",
  "12月22日+1分22秒",
  "12月23日+0分52秒",
  "12月24日+0分23秒",
  "12月25日+0分7秒",
  "12月26日+0分37秒",
  "12月27日-1分6秒",
  "12月28日-1分36秒",
  "12月29日-2分5秒",
  "12月30日-2分34秒",
  "12月31日-3分3秒"
]